import { render } from "./ToDoItem.vue?vue&type=template&id=683d1979&ts=true"
import script from "./ToDoItem.vue?vue&type=script&lang=ts"
export * from "./ToDoItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__